import { GET_REQUIREMENT_BY_ID } from '../../endpoints';
import { IRequirement } from '../../types/brand';
import makeAuthenticatedRequest from '../base-api';

const getRequirementByIdApi = async (reqId: string): Promise<IRequirement> => {
  try {
    const response = await makeAuthenticatedRequest(
      GET_REQUIREMENT_BY_ID(reqId)
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getRequirementByIdApi };
